// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__19NpA","inputWrap":"CustomTip_inputWrap__146iK"};